import React from 'react';
import { Button } from '../ui/button';
import { Apple, ArrowRight, Shield } from 'lucide-react';
import { toast } from 'sonner';

const Hero = () => {
  const handleAppStoreClick = () => {
    toast('Coming Soon', {
      description: 'The app will be available on the App Store shortly!',
    });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1722094250550-4993fa28a51b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
          alt="Person meditating on lake dock"
          className="w-full h-full object-cover object-right"
        />
        {/* Subtle overlay for text readability - minimal, not green */}
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/70 via-slate-900/40 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 lg:py-40 w-full">
        <div className="max-w-xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-8">
            <Shield className="w-4 h-4 text-teal-300" />
            <span className="text-sm font-medium text-white/90">Stronger Every Day</span>
          </div>

          {/* Main headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight mb-6">
            <span className="block text-white">Building a</span>
            <span className="block text-white">Stronger Future</span>
            <span className="block text-white mt-2">
              through{' '}
              <span className="text-teal-300">Active</span>
            </span>
            <span className="block text-teal-300">
              Diabetes Care
            </span>
          </h1>

          {/* Tagline */}
          <p className="text-lg lg:text-xl text-white/90 font-normal leading-relaxed max-w-lg mb-6">
            Empowering individuals in their diabetes management journey.
          </p>

          {/* Description */}
          <p className="text-base text-white/70 max-w-lg leading-relaxed mb-8">
            The all-in-one diabetes management app that tracks glucose, fitness, nutrition, and mental wellness — giving you complete control of your health journey.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg" 
              className="bg-white hover:bg-white/90 text-slate-900 px-8 py-6 text-lg rounded-2xl shadow-xl shadow-black/20 hover:shadow-2xl transition-all duration-300 group"
              onClick={handleAppStoreClick}
            >
              <Apple className="w-5 h-5 mr-2" />
              App Store
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-white/50 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
